module.exports = __webpack_public_path__ + "static/5-2781c80fa1ba9194f5eeb25fde51f94e.jpeg";